import React from 'react';
import s from './chatStyles';

/**
 * Etiquetas de una conversación: chips (clic para quitar) y selector para añadir.
 */
export default function TagPicker({ conv, allTags, open, onToggle, onAdd, onRemove }) {
  return (
    <div style={s.convTagsRow}>
      {(conv.tags || []).map(tag => (
        <span
          key={tag.id}
          onClick={e => { e.stopPropagation(); onRemove(conv.session_id, tag.id); }}
          style={{ ...s.convTagChip, background: tag.color + '25', border: `1px solid ${tag.color}50` }}
          title="Clic para quitar"
        >
          {tag.emoji} {tag.name}
        </span>
      ))}
      <span
        onClick={e => { e.stopPropagation(); onToggle(conv.session_id); }}
        style={s.addTagBtn}
        title="Añadir etiqueta"
      >+ etiqueta</span>

      {open && (
        <div style={s.tagPicker} onClick={e => e.stopPropagation()}>
          {allTags
            .filter(t => !conv.tags?.some(ct => ct.id === t.id))
            .map(t => (
              <div
                key={t.id}
                onClick={() => onAdd(conv.session_id, t.id)}
                style={s.tagPickerItem}
                className="ui-row"
              >
                {t.emoji} {t.name}
              </div>
            ))}
        </div>
      )}
    </div>
  );
}
